// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"45":"3b49c19a967b96fd","189":"0bda77286cef1b0b","821":"f726385c1b4d36dc"}[chunkId] + ".js";
};